// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PhoneOutlinedSvg from "@ant-design/icons-svg/es/asn/PhoneOutlined";
import AntdIcon from '../components/AntdIcon';

var PhoneOutlined = function PhoneOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PhoneOutlinedSvg
  }));
};

PhoneOutlined.displayName = 'PhoneOutlined';
export default React.forwardRef(PhoneOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/PhoneOutlined.js
// module id = 1555
// module chunks = 0